import { Layout, Contact } from '@rumblefish/ui/Rumblefish23Theme';
import { NextHeadWithMeta } from '../NextHeadWithMeta';
import { Benefits } from './Benefits/Benefits';
import { Faq } from './Faq';
import { Hero } from './Hero/Hero';
import { Portfolio } from './Portfolio';
import { Testimonial } from './Testimonial';
import { uiuxSeo } from './UiUx.seo';
import type { UiUxProps } from './UiUx.types';
import { UiUxServices } from './UiUxServices/UiUxServices';

export const UiUxPage = ({ blogPosts }: UiUxProps) => {
  return (
    <Layout blogPosts={blogPosts}>
      <NextHeadWithMeta {...uiuxSeo} />
      <Hero />
      <UiUxServices />
      <Portfolio />
      <Testimonial />
      <Benefits />
      <Faq />
      <Contact color="blue" />
      <NextHeadWithMeta />
    </Layout>
  );
};
